import AppState from '../../types/app-state'
import {UserData} from '../users/state'

export const currentUserSelector = (state: AppState): UserData => state.currentUser.currentUser

export const isFetchingCurrentUserSelector = (state: AppState): boolean =>
    state.currentUser.isFetching
